import {Mapper} from '@s-ui/domain'

const NO_COMMITMENT_OPTION = 0

export class HttpSubscriptionCommitmentOptionsResponseToSubscriptionCommitmentOptionsValueObjectMapper extends Mapper {
  constructor({subscriptionCommitmentOptionsValueObjectFactory}) {
    super()
    this._subscriptionCommitmentOptionsValueObjectFactory = subscriptionCommitmentOptionsValueObjectFactory
  }

  map(commitmentOptionsResponse) {
    const {commitmentMonths: commitmentOptions} = commitmentOptionsResponse

    const commitmentMonths = commitmentOptions.filter(Boolean)
    const hasNoCommitmentOption = commitmentOptions.includes(NO_COMMITMENT_OPTION)

    return this._subscriptionCommitmentOptionsValueObjectFactory({
      hasNoCommitmentOption,
      commitmentMonths
    })
  }
}
